var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSmartPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 4C4.25 2.48122 5.48122 1.25 7 1.25H17C18.5188 1.25 19.75 2.48122 19.75 4V20C19.75 21.5188 18.5188 22.75 17 22.75H7C5.48122 22.75 4.25 21.5188 4.25 20V4ZM7 2.75C6.30964 2.75 5.75 3.30964 5.75 4V20C5.75 20.6904 6.30964 21.25 7 21.25H17C17.6904 21.25 18.25 20.6904 18.25 20V4C18.25 3.30964 17.6904 2.75 17 2.75H7Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 19C10.25 18.5858 10.5858 18.25 11 18.25H13C13.4142 18.25 13.75 18.5858 13.75 19C13.75 19.4142 13.4142 19.75 13 19.75H11C10.5858 19.75 10.25 19.4142 10.25 19Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7121 2.23607L14.94 4.55228C14.94 4.55228 14.94 4.55229 14.94 4.5523C14.7018 5.2669 14.0331 5.7489 13.2798 5.7489H10.7214C9.96806 5.7489 9.29934 5.2669 9.06114 4.5523C9.06114 4.5523 9.06114 4.55229 9.06114 4.55229L8.28906 2.23607L9.71209 1.76172L10.4842 4.07795L10.4842 4.07796C10.5182 4.18003 10.6137 4.2489 10.7214 4.2489H13.2798C13.3875 4.2489 13.4829 4.18004 13.517 4.07798L13.517 4.07795L14.2891 1.76172L15.7121 2.23607Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmartPhone);
export default __webpack_public_path__ + "static/media/ic-smart-phone.cbddee4aa989de614742a15815bbb1c3.svg";
export { ForwardRef as ReactComponent };